// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__2FUA2","header":"Hero_header__1FOiT"};